import AlgoliaData from '@module/Algolia/resources/js/search/interfaces/AlgoliaData';
import ProductData from '../interfaces/ProductData';
import StoreData from '../interfaces/StoreData';
import ArticleData from '../interfaces/ArticleData';
import CollectionData from '../interfaces/CollectionData';
import UserManualData from '../interfaces/UserManualData';
import { formatUrl, getData, getImage } from '@module/Algolia/resources/js/search/helpers';
import {
  transformArticle as baseTransformArticle,
  transformProduct as baseTransformProduct,
  transformStore as baseTransformStore,
} from '@module/Algolia/resources/js/search/transformers';
import moment from '@phoenix/moment';
import { FEATURE_FLAG, getFeatureFlag } from '@phoenix/helpers/feature-flag-helper';

export const transformProduct = (data: AlgoliaData): ProductData => {
  const base = baseTransformProduct(data);

  return {
    ...base,
    description: getData(data.subtitle) ?? base.description,
    labels: (getData(data.labels, []) as string[])
      .filter((label) => label !== 'Product.isEcomExclusivity.label' || getFeatureFlag(FEATURE_FLAG.ECOM))
      .map((label) => ({
        isPalladiumTag: label.includes('standardizedLimitedEdition'),
        isSecondaryTag: label.includes('alreadySold'),
        name: label,
        value: window.Phoenix.i18n.t(label),
      })),
    searchImg: getImage(getData(data.imageCardHorizontal), base.name),
    sliderImages: getData(data.sliderImages, []),
  };
};

export const transformStore = (data: AlgoliaData): StoreData => ({
  ...baseTransformStore(data),
  inlineServices: (getData(data.services, []) as string[])
    .map((item) => window.Phoenix.i18n.t(`Store.services.${item}`))
    .join(' - '),
});

export const transformArticle = (data: AlgoliaData): ArticleData => ({
  ...baseTransformArticle(data),
  preTitle: getData(data.preTitle, ''),
  publicationDate: moment(data.publicationDate).format('MMM D, YYYY'),
  searchImg: getImage(getData(data.imageNewsCard), getData(data.title, '')),
});

export const transformCollection = (data: AlgoliaData): CollectionData => {
  const title: string = getData(data.title, '');

  return {
    id: getData(data.itemId, ''),
    link: formatUrl(getData(data.url, '')),
    rokkaImg: getImage(getData(data.imagePushCard), title),
    title,
  };
};

export const transformUserManual = (data: AlgoliaData): UserManualData => {
  const userManuals = getData(data.userManuals, '', true, ['en'], true, true) as { key: string; value: string };

  return {
    engravedReference: getData(data.engravedReference, ''),
    label: [getData(data.modelReference, ''), getData(data.title, '')].filter((value) => value !== '').join(' - '),
    language: userManuals.key ?? '',
    model: getData(data.modelReference, ''),
    url: userManuals.value ?? '',
  };
};
